'use client'

import * as React from 'react'
import { LogOut } from 'lucide-react'

import type { RenderLink } from '@ui/web/utils'
import { typographyVariants } from '@ui/web/lib'
import cn from '@config/tailwind/cn'

interface TopNavProps {
  renderBackLink: RenderLink
  ref: React.RefObject<HTMLDivElement | null>
}

export function TopNav({ renderBackLink, ref }: TopNavProps) {
  return (
    <nav
      ref={ref}
      className='srd:w-full srd:p-4 srd:absolute srd:top-0 srd:left-0 srd:z-20 srd:flex srd:items-center srd:gap-4 srd:bg-neutral-white srd:border-b srd:border-outline'
    >
      {renderBackLink({
        children: <LogOut className='srd:size-6 srd:text-neutral-black srd:rotate-180' />,
        className: 'srd:flex srd:items-center srd:justify-center',
      })}
      <span className={cn(typographyVariants({ variant: 'title-md' }), 'srd:text-neutral-black')}>Modul Latihan</span>
    </nav>
  )
}
